import styled from "styled-components";

import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import LabelsAPI from "@/api/labels/label_api.js";
import ComboButton from "@/Monolith-UI/ComboButton/ComboButton.js";
import PrinterSelectModal from "@/utils/labels/PrinterSelectPopup.js";
import { useTheme } from "@monolith-forensics/monolith-ui";
import { StorageItem } from "@/Features/Storage/Tables/types";

// Local shape for the legacy labels API rows; no Features type exists for them.
interface ItemLabel {
  label_name?: string;
  [key: string]: unknown;
}

interface OverviewContentProps {
  className?: string;
  storageInfo: StorageItem;
}

const OverviewContent = styled(
  ({ className, storageInfo }: OverviewContentProps) => {
    const theme = useTheme();
    const [showPrintLabelModal, setShowPrintLabelModal] = useState(false);
    const [selectedLabel, setSelectedLabel] = useState<ItemLabel | null>(null);

    const { data } = useQuery({
      queryKey: ["item-labels"],
      queryFn: () => LabelsAPI.getLabels(),
    });

    const handlePrintLabel = (label: ItemLabel) => {
      setSelectedLabel(label);
      setShowPrintLabelModal(true);
    };

    const onPrintLabel = () => {};

    return (
      <div className={className}>
        <div className="action-menu">
          <ComboButton
            type="dropDown"
            data={data || []}
            title={"Actions"}
            showDropdownIcon={true}
            displayField="label_name"
            variant="outlined"
            useSelectMode={false}
            selectedItems={[]}
            onItemSelect={handlePrintLabel}
            textColor={theme.palette.text.primary}
          >
            Print Label
          </ComboButton>
        </div>
        <div className="description-container">
          <div className="description-header">Description</div>
          <div>{storageInfo.notes || "No Description"}</div>
        </div>
        <PrinterSelectModal
          open={showPrintLabelModal}
          handleClose={() => setShowPrintLabelModal(false)}
          onSubmit={() => onPrintLabel()}
          defaultInfo={{ storage: storageInfo }}
          label={selectedLabel}
        />
      </div>
    );
  }
)`
  display: flex;
  flex-direction: column;
  gap: 10px;

  overflow-y: hidden;

  .action-menu {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
  }
  .description-container {
    padding: 20px;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    border-radius: 5px;
    white-space: pre-wrap;
    font-size: 12px;

    overflow-y: auto;
  }
  .description-header {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 12px;
    font-weight: 500;
    cursor: default;
    margin-bottom: 10px;
  }
`;

export default OverviewContent;
